import { atom } from "recoil";


export const StateStatus = atom({
    key: "StateStatus",
    default: true,
})
